var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderlogom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.808594,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FFF5ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.0003 16.7041L10.4351 13.4845C10.659 13.1557 10.9349 12.8864 11.2218 12.7275L11.2219 12.7275L14.7819 10.7541L14.7819 10.7541L14.7835 10.7532C15.1014 10.5748 15.5415 10.4759 16.0003 10.4759C16.4591 10.4759 16.8992 10.5748 17.2171 10.7532L17.2171 10.7532L17.2187 10.7541L20.7787 12.7275L20.7788 12.7275C21.0657 12.8864 21.3416 13.1557 21.5655 13.4845L16.0003 16.7041Z",
    fill: "#F85417",
    stroke: "#F85417",
    strokeWidth: 0.666667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M15.6671 23.1239C15.3327 23.0882 15.0234 22.9988 14.7836 22.8642L14.782 22.8634L11.222 20.89L11.2219 20.8899C10.883 20.7023 10.5555 20.3598 10.3117 19.9464C10.068 19.533 9.92708 19.0811 9.92708 18.6949V14.9216C9.92708 14.6585 9.9951 14.3645 10.1178 14.07L15.6671 17.2805V23.1239Z",
    fill: "#F85417",
    stroke: "#F85417",
    strokeWidth: 0.666667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7795 20.8899L20.7794 20.89L17.2194 22.8634L17.2178 22.8642C16.978 22.9989 16.6687 23.0882 16.3343 23.1239V17.2805L21.8836 14.07C22.0063 14.3645 22.0743 14.6585 22.0743 14.9216V18.6949C22.0743 19.0811 21.9334 19.533 21.6897 19.9464C21.4459 20.3598 21.1184 20.7023 20.7795 20.8899Z",
    fill: "#F85417",
    stroke: "#F85417",
    strokeWidth: 0.666667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderlogom);
export default __webpack_public_path__ + "static/media/orderlogom.0199d7e04f8b1cfabe58e3789c9a2345.svg";
export { ForwardRef as ReactComponent };